import React from "react";
import { KYC_MANUAL_NAMES } from "../config";
import { Box } from "@material-ui/core";
import BackButton from "../../../../shared/components/BackButton";
import KycManualDocIdInfo from "../steps/KycManualDocIdInfo";
import KycManualPersonalInfo from "../steps/KycManualPersonalInfo";
import AdditionalData from "../../shared/AdditionalData/AdditionalData";
import KycManualBirthInfo from "../steps/KycManualBirthInfo";
import { useKycManual } from "../hooks/useKycManual";

export const KycManualInternational = ({
  disableMaritalRegime,
  disableOthers,
}) => {
  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: KYC_MANUAL_NAMES.DOC_ID_FORM,
      show: () => true,
    },
    {
      id: KYC_MANUAL_NAMES.PERSONAL_INFO_FORM,
      show: () => true,
    },
    {
      id: KYC_MANUAL_NAMES.BIRTH_INFO_FORM,
      show: () => true,
    },
    {
      id: KYC_MANUAL_NAMES.ADDITIONAL_DATA_GROUP,
      show: () => true,
      isGroup: true,
    },
  ];

  const {
    currentModuleStepHandler,
    stepGroupStepToShow,
    submitStep,
    onBack,
    backButtonVisible,
    getStepData,
  } = useKycManual({ disableMaritalRegime, STEP_GROUP_STEPS_ARRAY });

  const showNieEu = () => true;
  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton onBack={onBack} show={backButtonVisible} />
      </Box>
      {stepGroupStepToShow === KYC_MANUAL_NAMES.DOC_ID_FORM && (
        <KycManualDocIdInfo onSubmitForm={submitStep} data={getStepData()} />
      )}
      {stepGroupStepToShow === KYC_MANUAL_NAMES.PERSONAL_INFO_FORM && (
        <KycManualPersonalInfo onSubmitForm={submitStep} data={getStepData()} />
      )}
      {stepGroupStepToShow === KYC_MANUAL_NAMES.BIRTH_INFO_FORM && (
        <KycManualBirthInfo onSubmitForm={submitStep} data={getStepData()} />
      )}
      {stepGroupStepToShow === KYC_MANUAL_NAMES.ADDITIONAL_DATA_GROUP && (
        <AdditionalData
          showNieEuFunc={showNieEu}
          currentModuleStepHandler={currentModuleStepHandler}
          disableMaritalRegime={disableMaritalRegime}
          disableOthers={disableOthers}
        />
      )}
    </>
  );
};
